import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import axiosService from '../lib/axios';
import { AxiosResponse, AxiosError } from 'axios';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.
export interface AppSettingsState  {
    authentication: AuthenticationSettings;
    key1: string;
    key2: string;
}

export interface AppSettings {
    authentication: AuthenticationSettings;
    key1: string;
    key2: string;
}

export interface AuthenticationSettings {
    provider: string;
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.
// Use @typeName and isActionType for type detection that works even after serialization/deserialization.

export interface requestAppSettingsAction { type: 'FETCH_APPSETTINGS'; appSettings: AppSettings; }

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownAction = requestAppSettingsAction;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    requestAppSettings: (): AppThunkAction<KnownAction> => (dispatch) => {
        axiosService.get(`api/AppSettings`)
        .then((response: AxiosResponse<AppSettings>) => {
          const { data } = response;
          dispatch({ type: 'FETCH_APPSETTINGS', appSettings: data });
        })
        .catch((error: AxiosError) => {
          console.log('AXIOSERROR::' + error.message);
          throw error;
        });
    }
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.

const unloadedState: AppSettingsState = { authentication: { provider: '' }, key1: '', key2: '' };

export const reducer: Reducer<AppSettingsState> = (state: AppSettingsState | undefined, incomingAction: Action): AppSettingsState => {
    if (state === undefined) {
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'FETCH_APPSETTINGS':
            return {  
                authentication: action.appSettings.authentication,
                key1: action.appSettings.key1,
                key2: action.appSettings.key2
            };
    }

    return state;
};
